import React from 'react';
import { Button, Modal, Form, Input, message } from 'antd';
import { hex_md5 } from '../../utils/md5';
import moment from 'moment';

class DynamicPasswordView extends React.Component {

    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }

    onClick(type) {
        switch (type) {
            case 'confirm':
                this.props.form.validateFieldsAndScroll((error, fields) => {
                    if (error) {
                        return;
                    }
                    let timestamp = (new Date()).getTime();
                    let time = moment(timestamp).format('HHDDMMYYYY')
                    let dynamicPassword = hex_md5(time);
                    if (dynamicPassword !== fields.dynamicPassword) {
                        message.error('动态密码错误');
                        return;
                    }
                    this.props.onModalFinish(this.props.type);
                });
                break;
            default:
                break;
        }
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }
        };
        return (
            <Modal title={'动态密码'} visible={true} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} onCancel={this.props.onModalCancel}>
                <Form>
                    <Form.Item {...formItemLayout} label="动态密码">
                        {this.props.form.getFieldDecorator('dynamicPassword', {
                            rules: [{ required: true, message: '请输入动态密码' }]
                        })(
                            <Input placeholder="请输入动态密码" maxLength="100" />
                        )}
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 20, offset: 4 }}>
                        <Button type="primary" onClick={() => this.onClick('confirm')}>确定</Button>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }

}

const DynamicPasswordModal = Form.create()(DynamicPasswordView);
export default DynamicPasswordModal;


// WEBPACK FOOTER //
// ./src/page/jsx/DynamicPasswordModal.jsx